import { Options, Vue } from 'vue-class-component';
import { AuthorizedUser } from '@/trust-admin-app/models/authorized-user';
import store from '@/trust-admin-app/store';
import { TrustTeamMemberView } from '@/shared/modules/typescript-trustapi-client/models';
import { Inject } from 'vue-property-decorator';
import { TrustAPI } from '@/shared/modules/trust-api';
import LoadingSpinner from '@/shared/components/loading-spinner/index.vue';
import { RouteN } from '@/trust-admin-app/constants/router-name';
import { AppInsights } from '@/trust-admin-app/appInsights';
import { EventEmitter } from 'events';
import { RoleType } from '@/trust-admin-app/models/user';
@Options({
  components: {
    LoadingSpinner
  }
})
export default class InvestigatorMain extends Vue {

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  private validatingEntrance = false;
  private ai = new AppInsights;

  created(): void {
    this.validateEntrance();
  }

  mounted(): void {
    window.scrollTo(0, 0);
  }

  beforeUnmount(): void {
    store.dispatch('setSelectedTrustTeamMember',  {});
  }

  private async validateEntrance(): Promise<void> {
    this.validatingEntrance = true;
    const trustMemberId: number = parseInt(this.$route.query.memberId as string, 10);
    try {
      if (!this.$route.query.memberId) {
        throw new Error('No Trust Member selected');
      } else if (this.selectedTrustTeamMember.id === trustMemberId) {
        this.validatingEntrance = false;
      } else if (this.selectedTrustTeamMember.id !== trustMemberId) {
        const resp: any =
        await this.apiService.TrustTeamMemberApi?.apiV2TrustTeamMemberGetTrustTeamMemberByIdMemberIdGet(
          trustMemberId
        );
        
        if(resp.data.data || resp.data.data?.id > 0) {
          store.dispatch('setSelectedTrustTeamMember',  resp.data.data as TrustTeamMemberView);
          this.validatingEntrance = false;
        } else {
          throw new Error('Invalid Trust Member');
        }
      }

      if (this.selectedTrustTeamMember.userGroup.name == RoleType.TrustSuperAdmin) {
        throw new Error('Not Valid Trust Member');
      }
    } catch (err: any) {
      this.eventCtrl.emit('show-snackbar', 'error', 'Invalid Trust Member');
      this.ai.trackException('Error loading page: ' + 'Invalid Trust Member');
      this.$router.push({ name: RouteN.TA.Home.n});
    } finally {
      this.validatingEntrance = false;
    }
  }


  get usrAcct(): AuthorizedUser {
    return store.getters.getUserAccount;
  }

  get selectedTrustTeamMember(): TrustTeamMemberView {
    return store.getters.getSelectedTrustTeamMember;
  }

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

}

